import { Component, AfterViewInit, ViewChild} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { formatDistance } from 'date-fns';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { Order } from 'src/interfaces/order';

@Component({
  selector: 'core-batch-order-list',
  templateUrl: './batch-order-list.component.html',
  styleUrls: ['./batch-order-list.component.scss']
})
export class BatchOrderListComponent implements AfterViewInit{

  displayedColumns: string[] = [
    'orderNumber',
    'amount_required'
  ];

  ordersDataSource: MatTableDataSource<Order>;
  page: number = 1; 
  limit: number = 15;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private prescriptionService: PrescriptionService,
    private router: Router
  ) { }

  ngAfterViewInit(): void {
    (async () => {
      const orders = await this.prescriptionService.getOrders(this.page, this.limit);
      this.ordersDataSource = new MatTableDataSource<Order>(orders);
      this.ordersDataSource.paginator = this.paginator;
      this.ordersDataSource.sort = this.sort;
    })();
  }

  onPageChange(event: PageEvent){

    if((event.pageSize * (event.pageIndex + 1)) === event.length){
      // Get more orders 
      this.page += 1;

      (async () => {
        const newOrders = await this.prescriptionService.getOrders(this.page, this.limit);
        const newData = [
          ...this.ordersDataSource.data,
          ...newOrders
        ] 
        this.ordersDataSource.data = newData;
      })();
      
    }

  }

  openOrder(id: any) {
    if (id)
      this.router.navigate(["portal/prescriptions/review/", id]);
  }

  getIndividualId(order: Order) {

    if (order.client) return order.client.id;

    if (order.doctor) return order.doctor.id;

    if (order.patient) return order.patient.id;

    return null;
  }

  getCreationTime(order: Order) {
    return formatDistance(new Date(order.created_at), new Date(), { addSuffix: true });
  }

  getAmountRequired(order: Order) {
    return 0;
  }

  getOwnerName(order: Order): string {

    if (order.client) return order.client.name;

    if (order.doctor) return order.doctor.first_name + " " + order.doctor.last_name;

    if (order.patient) return order.patient.first_name + " " + order.patient.last_name;

    return "No owner";
  }

}
